// Internal deps
 import { 
  getFirstDateRequest,
  postUserTrazabilityReport,
  getFirstLogin,
  getInfoProfile
} from "../services/administrationService";


 // TRAZABILITY REPORT
 export const getFirstDateRequestAdapter = () => new Promise((resolve, reject) => {
    getFirstDateRequest()
    .then((res) => resolve(res.data))
    .catch((err) => reject(err));
  });
  
  export const postUserTrazabilityReportAdapter = (data, nameFile) => new Promise((resolve, reject) => {
    const newDateTo = new Date(data.dateTo);
    const newDateFrom = new Date(data.dateFrom);
  
    const body = {
      dateFrom: newDateFrom.toISOString(),
      dateTo: newDateTo.toISOString()
    };
    postUserTrazabilityReport(body).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${nameFile}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });

// USER PROFILE
export const getFirstLoginAdapter = () => new Promise((resolve, reject) => {
  getFirstLogin()
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => reject(err));
});

export const getInfoProfileAdapter = () => new Promise((resolve, reject) => {
  getInfoProfile()
    .then((res) => {
      resolve({
        requestId: res.data.id,
        process: res.data.process,
        requestNumber: res.data.number,
        firstName: res.data.firstName,
        lastName: res.data.lastName,
        email: res.data.email,
        userName: res.data.userName,
        status: res.data.status,
        provider: res.data.supplier,
        cuit: res.data.cuit,
        groups: res.data.groups?.map((item) => item.groups?.map((group) => ({
          userGroup: {
            ...group
          }
        }))).flat(),
        roles: res.data.roles,
        uunn: res.data.businessUnits,
        services: res.data.services,
        edit: res.data.edit
      });
    })
    .catch((err) => reject(err));
});
